import { fetchTelegramIdentityRequest } from '../fetch-telegram-identity-request';
import type { IUnlinkTelegramOidcResponse } from './unlink-telegram-oidc-response';
import { unlinkTelegramOidcResponseSchema } from './unlink-telegram-oidc-response';

export async function unlinkTelegramOidcApi(): Promise<IUnlinkTelegramOidcResponse> {
  const response = await fetchTelegramIdentityRequest('/telegram/oidc/link', {
    method: 'DELETE',
  });
  if (!response.ok) {
    throw new Error(`Telegram OIDC unlink failed: ${response.status}`);
  }
  const json = await response.json();
  return unlinkTelegramOidcResponseSchema.parse(json);
}
